module.exports = __webpack_public_path__ + "static/f8-2-9b615068540f579d92aef0542e472b71.jpeg";